import BaseFactorBlock from "./BaseFactorBlock";
import { BaseFactorState } from "./BaseFactorState";

/** Etat initial pour le facteur
 * @template TFactorContext Type de FactorBlock spécialisé pour une feature Analysis
 */
export default class BaseInitState<TFactorContext extends BaseFactorBlock> extends BaseFactorState<TFactorContext> {
    public constructor() {
		super();
	}
    
    /** Sur l'entrée dans l'etat
     * @param args Paramètres optionnels
     */
    public Enter(args?: any): void {
        console.debug("BaseInitState - Enter()");
    }
    
    /** Sur sortie de l'état sur application
     * @param args Paramètres optionnels
     */
    public Next(args?: any): void {
        console.debug("BaseInitState - Next()");
    }

    /** Sur fermeture d'un etat */
    public Previous(args?: any): void {
        console.debug("BaseInitState - Previous()");
    }
}